import Vue from 'vue';
import Vuex from 'vuex';
import VueAxios from 'vue-axios';
import Events from './events';
import Server from './server';
import User from './user';
import General from './general';
import Data from './data';

Vue.use(Vuex, VueAxios);

export default new Vuex.Store({
  modules: {
    Events,
    User,
    Server,
    General,
    Data
  }
});
